<template>
  <ul class="my-3 list-unstyled">
    <li
      v-if="false"
      class="flex flex-wrap items-center relative border-bottom border-primary-20"
    >
      <router-link
        :to="dynamicProductPath('ready_birthday')"
        class="block py-2 flex-grow-1 font-medium no-decoration text-primary"
      >
        {{ t('birthday') }}
        <BalloonsSvg
          class="ml-2 my-n2"
          width="26"
          height="26"
        />
      </router-link>
    </li>
    <li
      class="flex flex-wrap items-center relative border-bottom border-primary-20"
    >
      <router-link
        v-if="isSignedIn"
        :to="{ name: 'customerCreditsPath' }"
        class="block py-2 flex-grow-1 font-medium no-decoration text-primary"
      >
        {{ t('my_credits') }}
        <span
          v-if="creditsSum >= 1"
          class="inline-block py-1 px-2 bg-danger rounded-pill text-nowrap text-sm text-white leading-1"
        >
          <span class="text-sm text-white leading-1"> {{ Math.floor(creditsSum) }} {{ t('currency') }}</span>
        </span>
      </router-link>
      <router-link
        v-else
        :to="{ name: 'signUpPath' }"
        class="block py-2 flex-grow-1 font-medium no-decoration text-primary"
      >
        {{ t('collect_credits') }}
      </router-link>
    </li>
    <li
      class="flex flex-wrap items-center relative border-bottom border-primary-20"
    >
      <router-link
        :to="dynamicProductPath('ready_new_products')"
        class="block py-2 flex-grow-1 font-medium no-decoration text-primary"
      >
        {{ t('new_products') }}
      </router-link>
    </li>
    <li
      v-for="(item, index) in items"
      :key="index"
      class="flex flex-wrap items-center relative border-bottom border-primary-20"
    >
      <router-link
        :to="item.link"
        class="block py-2 flex-grow-1 font-medium no-decoration text-primary"
      >
        {{ item.text }}
      </router-link>
    </li>
    <li
      v-if="locale === 'cs' || locale === 'sk' || locale === 'pl'"
      class="flex flex-wrap items-center relative border-bottom border-primary-20"
    >
      <router-link
        :to="{ name: 'distributorsPath' }"
        class="block py-2 flex-grow-1 font-medium no-decoration text-primary"
      >
        {{ t('distributors') }}
      </router-link>
    </li>
  </ul>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'

import ApiServiceV1 from '@/api/adminApi/AdminApiV1'
import BalloonsSvg from "@/components/svg/navbarMenu/BalloonsSvg.vue";
import { useCategoriesStore } from '@/stores/CategoriesStore'
import { storeToRefs } from 'pinia'
import { useAppStore } from '@/stores/AppStore'

const { t, locale } = useI18n()
const { dynamicProductPath } = useCategoriesStore()

const creditsSum = ref(0)
const appStore = useAppStore()
const { isSignedIn } = storeToRefs(appStore)


const items = [
  {
    text: t('about_us'),
    link: { name: 'aboutUsPath' },
  },
  {
    text: t('special_offers'),
    link: { name: 'discountsPath' },
  },
  {
    text: t('blog'),
    link: { name: 'blogPath' },
  },
]

const loadCredits = async () => {
  if (isSignedIn.value) {
    const { data } = await ApiServiceV1.get('customer/customer_credits')
    creditsSum.value = data.creditsSum
  }
}

loadCredits()
</script>

<i18n>
  {
    "cs": {
    "about_us": "O nás",
    "birthday": "Narozeniny",
    "blog": "Blog",
    "christmas": "Vánoce",
    "collect_credits": "Sbírat kredity",
    "currency": "Kč",
    "distributors": "Kde jsme",
    "easter": "Velikonoce",
    "my_credits": "Moje kredity",
    "new_products": "Novinky",
    "special_offers": "Výhodné nabídky",
    "valentine": "Valentýn"
},
    "sk": {
    "about_us": "O nás",
    "birthday": "Narodeniny",
    "blog": "Blog",
    "christmas": "Vianoce",
    "collect_credits": "Zbierať kredity",
    "currency": "€",
    "distributors": "Kde sme",
    "easter": "Veľká noc",
    "my_credits": "Moje kredity",
    "new_products": "Novinky",
    "special_offers": "Výhodné ponuky",
    "valentine": "Valentín"
},
    "pl": {
    "about_us": "O nas",
    "birthday": "Urodziny",
    "blog": "Blog",
    "christmas": "Boże Narodzenie",
    "collect_credits": "Zbieraj punkty",
    "currency": "zł",
    "distributors": "Tu jesteśmy",
    "easter": "Wielkanoc",
    "my_credits": "Moje punkty",
    "new_products": "Nowości",
    "special_offers": "Akcje i promocje",
    "valentine": "Walentynki"
},
    "hu": {
    "about_us": "Rólunk",
    "birthday": "Szülinap",
    "blog": "Blog",
    "christmas": "Karácsony",
    "collect_credits": "Kreditek",
    "currency": "Ft",
    "distributors": "Hol vagyunk",
    "easter": "Húsvét",
    "my_credits": "Kreditek",
    "new_products": "Újdonságok",
    "special_offers": "Kedvező ajánlataink",
    "valentine": "Valentin"
},
    "de": {
    "about_us": "Über uns",
    "birthday": "Geburtstag",
    "blog": "Blog",
    "christmas": "Weihnachten",
    "collect_credits": "Punkte sammeln",
    "currency": "€",
    "distributors": "Wo wir sind",
    "easter": "Ostern",
    "my_credits": "Meine Punkte",
    "new_products": "Neuheiten",
    "special_offers": "Vorteilhafte Angebote",
    "valentine": "Valentinstag"
},
    "at": {
    "about_us": "Über uns",
    "birthday": "Geburtstag",
    "blog": "Blog",
    "christmas": "Weihnachten",
    "collect_credits": "Punkte sammeln",
    "currency": "€",
    "distributors": "Wo wir sind",
    "easter": "Ostern",
    "my_credits": "Meine Punkte",
    "new_products": "Neuheiten",
    "special_offers": "Vorteilhafte Angebote",
    "valentine": "Valentinstag"
},
    "ro": {
    "about_us": "Despre noi",
    "birthday": "Aniversare",
    "blog": "Blog",
    "christmas": "Crăciun",
    "collect_credits": "Adună credite",
    "currency": "Lei",
    "distributors": "Unde suntem",
    "easter": "Paște",
    "my_credits": "Creditele mele",
    "new_products": "Noutăți",
    "special_offers": "Oferte speciale",
    "valentine": "Ziua Îndrăgostiților"
},
    "fr": {
    "about_us": "À propos de nous",
    "birthday": "Anniversaire",
    "blog": "Blog",
    "christmas": "Noël",
    "collect_credits": "Gagner des crédits",
    "currency": "€",
    "distributors": "Où sommes-nous",
    "easter": "Pâques",
    "my_credits": "Mes crédits",
    "new_products": "Nouveautés",
    "special_offers": "Offres avantageuses",
    "valentine": "Saint-Valentin"
},
    "it": {
    "about_us": "Chi siamo",
    "birthday": "Compleanno",
    "blog": "Blog",
    "christmas": "Natale",
    "collect_credits": "Accumulare i crediti",
    "currency": "€",
    "distributors": "Dove siamo?",
    "easter": "Pasqua",
    "my_credits": "I miei crediti",
    "new_products": "Novità",
    "special_offers": "Offerte convenienti",
    "valentine": "San Valentino"
}
  }
</i18n>
